import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function PackDetails() {
  const items = [{
    image: 'https://cdn.magicpatterns.com/uploads/kaBpsLkkjt9PL3nggXzme2/COVER_BOOK_PRINCIPAL.png',
    alt: 'Couverture du guide 10 Fraises Magiques par MuseFraise',
    title: 'Guide "10 Fraises Magiques"',
    description: 'Méthode Miroir + 10 designs viraux',
    value: '27$'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/3Viyo4DjS7t2Ln5Yfc6MT1/COVER_BONUS_1.png',
    alt: 'Couverture du Kit Imprimable Maman Chérie avec étiquettes et toppers',
    title: 'BONUS #1 : Kit Imprimable "Maman Chérie"',
    description: 'Étiquettes, cartes, toppers look boutique',
    value: '17$'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/dRQHu7RfFyLhBLqsmM3gSp/COVER_BONUS_2.png',
    alt: "Couverture du guide L'Art de l'Emballage sur tablette",
    title: 'BONUS #2 : Guide "Art de l\'Emballage"',
    description: 'Où trouver les boîtes pro à 2$ + secret du nœud parfait',
    value: '15$'
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-cream" data-id="element-153">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-5xl mx-auto" data-id="element-154">
        <h2 className="font-playfair text-2xl sm:text-3xl md:text-5xl font-bold text-burgundy text-center mb-3 md:mb-4" data-id="element-155">
          Tout ce qu'il te faut. Dans un seul accès.
        </h2>

        <p className="text-base sm:text-lg md:text-xl text-gray-700 text-center mb-8 md:mb-12 font-lato" data-id="element-156">
          Pour 9,97$, tu ne télécharges pas un PDF.
          <br data-id="element-157" />
          <span className="font-bold text-burgundy" data-id="element-158">
            Tu reçois un studio de création complet.
          </span>
        </p>

        <div className="bg-white rounded-xl md:rounded-2xl shadow-xl p-5 sm:p-6 md:p-12 mb-6 md:mb-8" data-id="element-159">
          <div className="space-y-6 mb-6 md:mb-8" data-id="element-160">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 pb-6 border-b border-gray-200 last:border-0 last:pb-0" data-id="element-161">
                <motion.div className="w-20 h-20 sm:w-28 sm:h-28 md:w-32 md:h-32 flex-shrink-0 rounded-lg sm:rounded-xl overflow-hidden shadow-md sm:shadow-lg" whileHover={{
              scale: 1.05,
              rotate: -2
            }} transition={{
              duration: 0.3
            }} data-id="element-162">
                  <img src={item.image} alt={item.alt} className="w-full h-full object-cover" data-id="element-163" />
                </motion.div>
                <div className="flex-1 text-center sm:text-left" data-id="element-164">
                  <h3 className="font-playfair text-base sm:text-lg md:text-xl font-bold text-burgundy mb-0.5 sm:mb-1" data-id="element-165">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 font-lato text-xs sm:text-sm md:text-base" data-id="element-166">
                    {item.description}
                  </p>
                </div>
                <div className="text-rose-gold font-bold text-xl sm:text-2xl font-lato flex-shrink-0" data-id="element-167">
                  {item.value}
                </div>
              </motion.div>)}
          </div>

          <div id="pack-pricing" className="border-t-2 border-burgundy pt-4 md:pt-6" data-id="element-168">
            <div className="flex justify-between items-center mb-3 md:mb-4" data-id="element-169">
              <span className="font-playfair text-base sm:text-lg md:text-xl text-gray-600" data-id="element-170">
                VALEUR TOTALE :
              </span>
              <span className="font-playfair text-lg sm:text-xl md:text-2xl text-gray-400 line-through" data-id="element-171">
                59,00$
              </span>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-center gap-1 sm:gap-0 mb-2" data-id="element-172">
              <span className="font-playfair text-lg sm:text-xl md:text-3xl font-bold text-burgundy text-center sm:text-left" data-id="element-173">
                TON PRIX AUJOURD'HUI :
              </span>
              <span className="font-playfair text-3xl sm:text-4xl md:text-5xl font-bold text-rose-gold" data-id="element-174">
                9,97$
              </span>
            </div>
            <p className="text-center sm:text-right text-sm sm:text-base text-green-700 font-lato font-semibold" data-id="element-175">
              Tu économises 49,03$. Et tu offres quelque chose d'inestimable.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-176">
          <CTAButton large subtitle="Paiement sécurisé — Accès sur ton téléphone en 30 secondes" data-id="element-177">
            OUI, JE VEUX LE PACK COMPLET 🍓
          </CTAButton>
        </div>
      </motion.div>
    </section>;
}